import React from 'react';
import { Link } from 'react-router-dom';

const HeroSection: React.FC = () => {
  return (
    <section className="bg-hero-pattern bg-cover bg-center min-h-screen flex items-center justify-center text-center px-4">
      <div className="container-custom py-32">
        <h2 className="text-white text-2xl md:text-4xl font-bold mb-6 max-w-3xl mx-auto">
          Delivering high quality services at affordable prices
          <div className="h-1 w-24 bg-gold mx-auto mt-4"></div>
        </h2>
        <Link to="/contact" className="btn-primary mt-8 inline-block">
          Get a Quote
        </Link>
      </div>
    </section>
  );
};

export default HeroSection;